import { AccordionDetails, Box, Typography } from "@mui/material";
import clsx from "clsx";
import React from "react";
import BriaAccordion from "../BriaAccordion/BriaAccordion";
import styles from "./BriaFaqSection.module.scss";
import { BriaFaqSectionProps, FaqAnswer } from "./faq";

const BriaFaqSection: React.FC<BriaFaqSectionProps> = ({
	title,
	faqItems,
	onLinkClick,
	onAnswerClick,
	className,
	titleClassName,
	accordionClassName,
}) => {
	const handleAnswerLinkClick = (id: string) => {
		if (onLinkClick) {
			onLinkClick(id);
		}
	};

	const renderAnswerContent = (answer: FaqAnswer[]) => {
		return answer.map((ans, i) => {
			switch (ans.type) {
				case "text":
				case "paragraph":
					return (
						<Typography
							key={i}
							className={styles.accordionDetails}
							dangerouslySetInnerHTML={{ __html: ans.content }}
							onClick={onAnswerClick}
						/>
					);

				case "paragraphWithListAndLink":
					return (
						<React.Fragment key={i}>
							<Typography
								className={styles.accordionDetails}
								dangerouslySetInnerHTML={{ __html: ans.intro }}
							/>
							{ans.list && (
								<ul className={styles.serviceList}>
									{(Array.isArray(ans.list)
										? ans.list
										: Object.values(ans.list as Record<string, string>)
									).map((li, j) => (
										<li
											key={j}
											className={styles.serviceListItem}
											dangerouslySetInnerHTML={{ __html: li }}
										/>
									))}
								</ul>
							)}
							{ans.midText && (
								<Typography
									className={styles.accordionDetails}
									dangerouslySetInnerHTML={{ __html: ans.midText }}
								/>
							)}
							{ans.linkText && ans.linkId && ans.outro && (
								<Typography className={styles.accordionDetails}>
									<Typography
										component="a"
										onClick={() => handleAnswerLinkClick(ans.linkId ?? "")}
										className={styles.linkUrl}
									>
										{ans.linkText}
									</Typography>
									{" " + ans.outro}
								</Typography>
							)}
						</React.Fragment>
					);

				default:
					return null;
			}
		});
	};

	return (
		<Box className={`${styles.faqSection} ${className || ""}`}>
			<Typography className={`${styles.faqTitle} ${titleClassName || ""}`}>{title}</Typography>

			{faqItems.map((item, index) => (
				<BriaAccordion
					key={index}
					className={clsx(styles.accordion, accordionClassName)}
					accordionTitle={item.question}
					useSecondaryIcons
				>
					<AccordionDetails>{renderAnswerContent(item.answer)}</AccordionDetails>
				</BriaAccordion>
			))}
		</Box>
	);
};

export default BriaFaqSection;
